import { EventEmitter, Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class MobileSidenavService {
    public toggleSidenav = new EventEmitter<void>();
}
